import { gql } from '@apollo/client'
import { buildTags, MetaTags } from '@jusbrasil-web/docview/core'

import { ModelMetaTags_DocumentFragment } from './__generated__/model-meta-tags.graphql'
import { ModelSeoMetadata } from './model-seo-metadata'

export type ModelMetaTagsProps = {
  document: ModelMetaTags_DocumentFragment
}

export function ModelMetaTags(props: ModelMetaTagsProps) {
  const { document } = props
  const { url } = document
  const seoMetadata = new ModelSeoMetadata(document).getSeoMetadata()
  const tags = buildTags({ document, seoMetadata })

  return <MetaTags url={url} tags={tags} />
}

ModelMetaTags.fragments = {
  document: gql`
    fragment ModelMetaTags_document on Document {
      title
      url
      meta
      noIndex

      ...MetaTags_document
    }
    ${MetaTags.fragments.document}
  `,
}
